/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions(value) {
    if (!('AppStoreUrl' in value) || value['AppStoreUrl'] === undefined)
        return false;
    if (!('AppStoreId' in value) || value['AppStoreId'] === undefined)
        return false;
    if (!('AppLinkUrl' in value) || value['AppLinkUrl'] === undefined)
        return false;
    if (!('BundleId' in value) || value['BundleId'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AppStoreUrl': json['AppStoreUrl'],
        'AppStoreId': json['AppStoreId'],
        'AppLinkUrl': json['AppLinkUrl'],
        'BundleId': json['BundleId'],
    };
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AppStoreUrl': value['AppStoreUrl'],
        'AppStoreId': value['AppStoreId'],
        'AppLinkUrl': value['AppLinkUrl'],
        'BundleId': value['BundleId'],
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions.js.map